module.exports = __webpack_public_path__ + "img/login.dcecae76.png";